import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Sprint} from "@app/interfaces/sprint";
import {SprintService} from "@components/sprint/sprint.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HelperService} from "@app/services/helper/helper.service";

export interface DialogData {
    id: string,
    mode: string
}

@Component({
    selector: 'app-add-sprint-modal',
    templateUrl: './add-sprint-modal.component.html',
    styleUrls: ['./add-sprint-modal.component.css']
})
export class AddSprintModalComponent implements OnInit {

    id = '';
    sprint: Sprint;
    modalTitle = 'Dodaj novi sprint';

    form: FormGroup;

    loader = true;


    constructor(@Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
                private sprintService: SprintService,
                private toastr: ToastrService,
                private dialogRef: MatDialogRef<AddSprintModalComponent>,
                private helperService: HelperService) {
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            'name': new FormControl('', Validators.required),
            'dateStart': new FormControl('', Validators.required),
            'dateEnd': new FormControl('', Validators.required),
            'sprintGoal': new FormControl('')
        });


        if (this.dialogData.mode == 'edit') {
            this.id = this.dialogData.id;
            this.getSprintData(this.id);
            this.modalTitle = 'Izmijeni sprint';
        } else {
            this.loader = false;
        }
    }

    getSprintData(id) {
        this.sprintService.getSprintData(id).subscribe((response: BackendResponse) => {
            if (response.type == 'success') {
                this.sprint = response.data;
                this.loader = false;
                this.form.patchValue({
                    name: this.sprint.name,
                    dateStart: this.helperService.tranformStringToDate(this.sprint.date_start),
                    dateEnd: this.helperService.tranformStringToDate(this.sprint.date_end),
                    sprintGoal: this.sprint.sprint_goal
                });
            } else {
                this.toastr.error('Došlo je do greške, molimo Vas obratite se korisničkoj podršci.');
                this.dialogRef.close();
            }
        })
    }

    closeModal() {
        this.dialogRef.close(false);
    }

    saveData() {
        let start: { year: number, month: number, day: number } = this.form.controls.dateStart.value;
        let startStr: any = start.year.toString() + '-' + start.month.toString() + '-' + start.day.toString();
        startStr = new Date(Date.parse(startStr));

        let end: { year: number, month: number, day: number } = this.form.controls.dateEnd.value;
        let endStr: any = end.year.toString() + '-' + end.month.toString() + '-' + end.day.toString();
        endStr = new Date(Date.parse(endStr));



        if (this.form.invalid) return;
        if (endStr < startStr) {

            this.toastr.info('Molimo Vas pravilno unesite datume');
            return;
        }
        let data: any = {};

        data.id = this.id;
        data.name = this.form.controls.name.value;
        data.dateStart = this.form.controls.dateStart.value;
        data.dateEnd = this.form.controls.dateEnd.value;
        data.sprintGoal = this.form.controls.sprintGoal.value;

        this.sprintService.saveSprintData('edit', data).subscribe((response: BackendResponse) => {
            if (response.type == 'success') {
                this.dialogRef.close(true);
            }
        })
    }


}
